import React from 'react';
import { IconBase } from '../Base';
export const IconBaseChain = (props) => {
    return (React.createElement(IconBase, { ...props },
        React.createElement("circle", { cx: "10", cy: "10", r: "7", style: { stroke: 'var(--icon-color)' }, strokeWidth: "1.5" }),
        React.createElement("path", { d: "M10 10.75C10.4142 10.75 10.75 10.4142 10.75 10C10.75 9.58579 10.4142 9.25 10 9.25V10V10.75ZM3 10V10.75H10V10V9.25H3V10Z", style: { fill: 'var(--icon-color)' } })));
};
//# sourceMappingURL=Base.js.map